import pageOne from "./01";

export default [...pageOne];
